import { api } from '@/api'

export default {
  getPreviewPdf: (id:number) => api.$get(`/inbound_invoices/${id}/preview_pdf`, {
    responseType: 'blob'
  })
}
